import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../actions";
import {
  Icon,
  Row,
  Col,
  Card,
  Typography,
} from "antd";



const { Title } = Typography;

class ExecuteShipment extends Component {
    state = {
        booking: {},
    }
    
  handleSaveDetails = () => {
    this.props.handleSaveDetails();
  };

  handleCardClick = () => {
    //this.props.onCardSelect("BookAndPay");
    this.props.onCardSelect("BookNow");
  };

  handleSignUpClick = () =>{
     this.props.onCardSelect("Signup");
  }

  handleAgentClick = () => {
    this.props.onCardSelect("BookThroughAgent");
  }


  render() {
    const cardTitleStyle = {
      fontSize: "16px",
      fontWeight: "600",
      padding: "1rem 0",
    };

    const cardStyle = {
      textAlign: "center",
      margin: "1rem 0",
      cursor:"pointer"
    };

    return (
      <div>
      <div>
        <div style={{ textAlign: "center", padding: "2rem 0.5rem" }}>
          <Title level={3}>Execute Shipments</Title>
        </div>
        <Row type="flex" justify="center">
          <Col xs={20} sm={20} md={12} lg={12} xl={12}>
            <Card style={{ width: "100%", textAlign: "center", margin:"2rem 0", cursor:"pointer" }}
              className="info-card-container"
              onClick={this.handleCardClick}
            >
              <div>
                <Icon
                  type="credit-card"
                  style={{ fontSize: "40px", color: "#2b2f89" }}
                  theme="outlined"
                />
              </div>
              {/* <p style={cardTitleStyle}>Book and Pay Now</p> */}
              <p style={cardTitleStyle}>Book Now</p>
              <p>
                {/* Pay for this shipment online using credit card, wire, e-cheque
                or EFT. Once the payment has been received your shipment will be
                executed. */}
                Book your shipment now, and we will provide you with detailed instructions on 
                how to complete the payment and proceed with the shipment execution.
              </p>
            </Card>
          </Col>
        </Row>
        <div style={{ textAlign: "center", padding: "3rem 0.5rem" }}>
          <Title level={3}>Or choose from the alternative options below:</Title>
        </div>
        <Row gutter={16} type="flex" justify="center" style={{margin:'0px'}}>
          <Col xs={20} sm={20} md={7} lg={7} xl={6}>
            <Card style={cardStyle}
               onClick={this.handleSignUpClick} >
              <div>
                <Icon
                  type="clock-circle"
                  style={{ fontSize: "25px" }}
                  theme="outlined"
                />
                {/* <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-clock" viewBox="0 0 16 16">
  <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
</svg> */}
              </div>
              <p style={cardTitleStyle}>
                Sign up for Prime Freight and Pay Later
              </p>
              <p>
                Create a Prime Freight account. Eligible businesses with
                multiple shipments per year can be approved to pay up to 45 days
                after delivery. Sign up is quick and is verification completed
                within 1-2 business days.
              </p>
            </Card>
          </Col>
          <Col //span={6}
            xs={20}
            sm={20}
            md={7}
            lg={7}
            xl={6}
          >
            <Card style={cardStyle} 
            onClick={() => { window.location.href = "https://calendly.com/primefreight/prime-freight-online-platform"; } }
            // onClick={() => {
            //   window.open("https://calendly.com/primefreight/prime-freight-online-platform", "_blank");
            // }}
             >
              <div>
                {/* <Icon type="phone" style={{ fontSize: '25px', color: '#2b2f89' }} theme="filled"/> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="currentColor"
                  className="bi bi-telephone-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                  />
                </svg>
              </div>
              <p style={cardTitleStyle}>Schedule a Call-Back</p>
              <p>
                Have a member of our team call you and guide you through booking
                this shipment, or call us at +1 (844) 977-4639
              </p>
            </Card>
          </Col>
          <Col //span={6}
            xs={20}
            sm={20}
            md={7}
            lg={7}
            xl={6}
          >
            <Card style={cardStyle}
              onClick={this.handleAgentClick}
            >
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="currentColor"
                  className="bi bi-person-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                </svg>
              </div>
              <p style={cardTitleStyle}>Book Through our Agent</p>
              <p>
                Book directly through our overseas representative. Provide our
                agent’s information to your supplier. Once they make a booking,
                you will receive an email confirmation.
              </p>
            </Card>
          </Col>
        </Row>
      </div>
      {/* )} */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    booking_customer_form:state.route.booking_customer_form
  };
};

export default connect(mapStateToProps, actions)(ExecuteShipment);
